// ==============================
// 파일명 : src/utils/uid.js
// 역할 : Firebase 사용자 UID가 필요한 지점에서 충돌을 최소화하도록
//         브라우저의 crypto.randomUUID와 시간을 활용해 예측하기 어려운
//         문자열을 생성하며, 호환성이 떨어지는 환경에서는 대체 로직을 제공
// 수정일 : 2025-10-13
// ==============================

const FALLBACK_UID_PREFIX = "usr"; // [수정] 기본 UID 접두사 설정
const FALLBACK_RANDOM_LENGTH = 12; // [수정] 대체 랜덤 문자열 길이 설정

const generateFallbackSegment = () => {
  const random = Math.random().toString(36).slice(2); // [수정] 36진수 난수 생성
  return random.padEnd(FALLBACK_RANDOM_LENGTH, "0").slice(0, FALLBACK_RANDOM_LENGTH); // [수정] 고정 길이로 보정
}; // [수정] 난수 세그먼트 생성 함수

export const generateUserAuthUid = () => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID(); // [수정] 지원되는 경우 브라우저 내장 UUID 사용
  }

  const timestamp = Date.now().toString(36); // [수정] 시간 기반 세그먼트 생성
  const randomSegment = generateFallbackSegment(); // [수정] 난수 세그먼트 확보
  return `${FALLBACK_UID_PREFIX}_${timestamp}_${randomSegment}`; // [수정] 접두사+시간+난수 조합 UID 반환
}; // [수정] 사용자 UID를 생성하는 공개 함수